// Alerts in the browser: a two-note chime made with Web Audio (no sound file),
// and the count on the installed app's icon where the browser has the Badging API.
import type { AppAlerts } from '@ims/app'

let audio: AudioContext | null = null

function note(ctx: AudioContext, frequency: number, start: number) {
  const tone = ctx.createOscillator()
  const gain = ctx.createGain()
  tone.type = 'sine'
  tone.frequency.value = frequency
  // A soft start and a quick fade, so it reads as a chime and not a beep.
  gain.gain.setValueAtTime(0.0001, start)
  gain.gain.exponentialRampToValueAtTime(0.25, start + 0.02)
  gain.gain.exponentialRampToValueAtTime(0.0001, start + 0.35)
  tone.connect(gain).connect(ctx.destination)
  tone.start(start)
  tone.stop(start + 0.4)
}

type BadgeNavigator = Navigator & {
  setAppBadge?: (count?: number) => Promise<void>
  clearAppBadge?: () => Promise<void>
}

export const browserAlerts: AppAlerts = {
  chime() {
    try {
      audio ??= new AudioContext()
      // Before the first tap the context is suspended and nothing plays: that is the
      // browser's rule, and the pop-up still shows.
      void audio.resume().catch(() => {})
      note(audio, 880, audio.currentTime)
      note(audio, 1174.66, audio.currentTime + 0.16)
    } catch {
      // No audio on this device.
    }
  },
  setBadge(count) {
    const nav = navigator as BadgeNavigator
    const done = count > 0 ? nav.setAppBadge?.(count) : nav.clearAppBadge?.()
    void done?.catch(() => {})
  },
}
